import mapconfig from './config';

let geocoder;
let geocoderLoading = false;
let geocoderLoaded = false;
let queryToLoad = false;
let queryCallback;
let country;
let api_key;

function initGeoCoder(){
    api_key = mapconfig.API_KEY;
    country = mapconfig.country;
    // this used to have lazyloading but its was removed after the switch to google maps instead of leaflet.js
    geocoderLoading = true;
    googleApiScriptLoaded();
}

function callGoogleApi(queryString, callback) {
    queryCallback = callback || function(){};
    if (isReady()){
        setQueryToLoad(queryString);
        searchGoogleMaps(queryString);
    } else {
        setQueryToLoad(queryString);
        initGeoCoder();
    }
}

function setQueryToLoad(queryString) {
    queryToLoad = queryString;
}

function googleApiScriptLoaded(){
    geocoderLoaded = true;
    geocoder = new google.maps.Geocoder();
    if (queryToLoad){
        searchGoogleMaps(queryToLoad);
        queryToLoad = false;
    }
}

function searchGoogleMaps(queryString){
    const queryObj = {
        address: queryString,
        componentRestrictions: {
            country: country
        }
    };
    geocoder.geocode( queryObj, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            queryCallback(true, {status: 'OK', result: results});
        } else {
            queryCallback(false, {status: status, result: results});
        }
    });
}

function isReady(){
    return (geocoderLoading && geocoderLoaded);
}

export default {
    initGeoCoder: initGeoCoder,
    isReady: isReady,
    googleApiScriptLoaded: googleApiScriptLoaded,
    searchGoogleMaps: searchGoogleMaps,
    setQueryToLoad: setQueryToLoad,
    callGoogleApi: callGoogleApi
};
